export default __webpack_public_path__ + "static/media/prod.955b0b69.svg";